import { categories } from '@/mocks/manga';
import SectionHeader from './SectionHeader';

const iconMap: Record<string, string> = {
  热血: 'ri-fire-fill',
  恋爱: 'ri-heart-fill',
  玄幻: 'ri-sparkling-2-fill',
  悬疑: 'ri-user-search-line',
  搞笑: 'ri-emotion-laugh-line',
  科幻: 'ri-rocket-2-fill',
  校园: 'ri-graduation-cap-fill',
  冒险: 'ri-compass-3-fill',
  奇幻: 'ri-magic-fill',
  都市: 'ri-building-2-fill',
};

export default function CategoriesSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="categories" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          align="center"
          eyebrow="分类导航"
          title="选择你喜欢的漫画分类"
          desc="十大热门分类，覆盖热血、恋爱、玄幻到科幻悬疑，极速加载海量作品，总有一部适合你。"
        />

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5 md:gap-5">
          {categories.map((c) => (
            <button
              key={c.name}
              type="button"
              onClick={() => scrollTo('popular')}
              className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 text-left transition-all duration-300 hover:-translate-y-0.5 hover:border-primary-300 hover:bg-background-50 cursor-pointer"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${iconMap[c.name] ?? 'ri-book-2-fill'} text-xl`}></i>
              </span>
              <span>
                <span className="block text-sm font-bold text-foreground-950">{c.name}漫画</span>
                <span className="block text-xs text-foreground-600">{c.count}</span>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}